import { Pipe, PipeTransform } from '@angular/core';
import { isScheduleInfoBasicDto, isScheduleItem } from '../helpers/helpers';
import { ScheduleDataState } from '../models/calendar/schedule/schedule-state';
import { CatalogBasic } from '../models/common/catalog-basic';
import { Role } from '../models/role/role';

@Pipe({
    name: 'filterTasks',
    pure: false
})
export class FilterTasksPipe implements PipeTransform {
    transform(
        items: any[],
        filterObject: {
            selectedRoles: Role[];
            selectedTypeEvents: CatalogBasic[];
            selectedStates: CatalogBasic[];
        }): any[] {
        let filterItems = items;

        if (filterObject.selectedRoles?.length) {
            filterItems = filterItems
                .filter(schedule => isScheduleItem(schedule))
                .filter(
                    schedule => filterObject.selectedRoles
                        .find(
                            role => role.id == (isScheduleItem(schedule)? schedule.idRol:0)
                        )
                );
        }

        if (filterObject.selectedTypeEvents?.length) {
            filterItems = filterItems
                .filter(
                    schedule => filterObject.selectedTypeEvents
                        .find(
                            typeEvent => typeEvent.value == (isScheduleItem(schedule) ? schedule.typeStaffTask:1)
                        )
                );
        }

        if (filterObject.selectedStates?.length) {
            filterItems = filterItems
                .filter(
                    schedule => filterObject.selectedStates
                        .find(
                            state => state.value == (isScheduleInfoBasicDto(schedule) ? schedule.currentState : (schedule.dateValidation ? ScheduleDataState.validated : ScheduleDataState.pending ))
                        )
                );
        }

        return filterItems;
    }
}
